import { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import Modal from "../../components/Modal";
import { Label } from "../../components/ui/label";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { requestService, requestDataMap } from "../../services";
import { createItemStore } from "../../stores/createItemStore";
import { Skeleton } from "../../components/ui/skeleton";
import { TextArea } from "../../components/ui/TextArea";
import { Input } from "../../components/ui/input";
import { GoLog } from "react-icons/go";
import { toast } from "react-toastify";
import MaterialSelectTransactions from "../../components/MaterialSelectTransactions";

const storeName = "requests";
const useItems = createItemStore(
  storeName,
  (request) => request.requestId,
  (args) => requestService.getRequests(args[0], args[1], args[2]),
  requestDataMap
);

const ViewUserPage = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const { requestId } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [comment, setComment] = useState("");
  const [editableData, setEditableData] = useState({
    materialId: "",
    quantity: "",
    transactionPoints: 0,
  });
  const [selectedMaterial, setSelectedMaterial] = useState(null);




  const { isLoading, fetchItems, getSortedFiltered } = useItems(
    (state) => state
  );
  const data = getSortedFiltered((request) => request.requestId === requestId);
  const showLoading = data.length === 0 && isLoading;
  const requestData = data?.[0] ?? {};

  console.log("Request Data: ", requestData);

  useEffect(() => {
    fetchItems({}, [undefined, undefined, requestId]);
  }, [requestId]);





  // Update editable data when requestData changes
  useEffect(() => {
    if (requestData) {
      setEditableData((prev) => ({
        ...prev,
        materialId: requestData.materialId || "",
        quantity: requestData.quantity || "",
        transactionPoints:
          requestData.transactionPoints ||
          (requestData.materialPoint || 0) * (requestData.quantity || 0),
      }));
    }
  }, [requestData]);

  const handleChange = (field, value) => {
    setEditableData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleMaterialChange = (material) => {
    setSelectedMaterial(material);
    handleChange("materialId", material?._id);
    handleChange("materialPoint", material?.point || 0);
    // Calculate transaction points when material changes
    calculateTransactionPoints(material?.point || 0, editableData.quantity);
  };

  const handleQuantityChange = (e) => {
    const newQuantity = e.target.value;
    setEditableData((prev) => ({
      ...prev,
      quantity: newQuantity,
    }));
    // Calculate transaction points when quantity changes
    calculateTransactionPoints(
      selectedMaterial?.point || requestData.materialPoint || 0,
      newQuantity
    );
  };

  const calculateTransactionPoints = (materialPoint, quantity) => {
    const points = Number(materialPoint) * Number(quantity || 0);
    handleChange("transactionPoints", points);
  };

  const handleConfirmApprove = async () => {
    try {
      setLoading(true);
      if (!requestId) {
        console.error("No requestId found");
        return;
      }

      // Ensure all numeric values are properly converted
      const quantity = Number(editableData.quantity) || 0;
      const materialPoint = Number(
        selectedMaterial?.point || requestData.materialPoint || 0
      );
      const transactionPoints = quantity * materialPoint;

      const requestPayload = {
        RequestId: requestId,
        TransactionPoint: transactionPoints,
        MaterialId: editableData.materialId,
        Quantity: quantity,
        Comment: comment,
        // Status: "AD" // Remove if not needed by API
      };

      console.log("Sending to API:", requestPayload); // Debug log

      const response = await requestService.acceptRequest(requestPayload);

      console.log("Request approved:", response);

      toast.success("🎉 Request has been approved successfully!", {
        autoClose: 2000,
      });
      setApproveModal(false);
      navigate("/pending-requests");
    } catch (error) {
      console.error("Failed to approve request:", error);
      toast.error("❌ Failed to approve request", {
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmReject = async () => {
    if (!requestData.requestId) {
      console.error("No request ID available.");
      return;
    }

    try {
      setLoading(true);
      const response = await requestService.rejectRequest({
        RequestId: requestData.requestId,
        Comment: comment || "Request rejected.",
        Status: "R",
      });

      console.log("Reject API Response:", response);
      toast.success("🎉 Request has been rejected successfully!", {
        autoClose: 2000,
      });
      setRejectModal(false);
      navigate("/pending-requests");
    } catch (error) {
      console.error("Failed to reject request:", error);
      toast.error("❌ Failed to reject request", {
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
    }
  };

  const isTransactionReview = requestData.type === "Transaction Review";
  console.log("editable quantity: ", editableData.quantity);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-1 flex flex-col">
        <div className="p-4 md:p-8 flex flex-col">
          {/* Header Section */}
          <div className="bg-white shadow p-4 pb-1 rounded-lg">
            <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-4 sm:gap-6 mb-4 sm:mb-6">
              <div className="flex flex-col sm:flex-row sm:items-center gap-4 w-full sm:w-auto">
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-yellow-400 flex items-center justify-center self-center sm:self-auto">
                  <GoLog className="w-8 h-8 sm:w-12 sm:h-12 text-white" />
                </div>

                <div className="text-center sm:text-left">
                  <h1 className="text-lg font-semibold text-[#111827]">
                    Pending Request
                  </h1>
                  <div className="mt-2 sm:mt-4 flex flex-col sm:flex-row sm:space-x-8">
                    <div>
                      <div className="text-sm font-semibold text-[#6B7280]">
                        Date Created
                      </div>
                      <div className="text-sm text-[#111827]">
                        {showLoading ? (
                          <Skeleton className="w-32 sm:w-40 h-4 sm:h-6" />
                        ) : (
                          requestData.dateCreated
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full sm:w-auto">
                <Button
                  variant={"hollowGreen"}
                  onClick={() => navigate("/pending-requests")}
                  className="w-full sm:w-auto"
                >
                  Cancel
                </Button>
                <Button
                  variant="destructive"
                  onClick={() => setRejectModal(true)}
                  className="w-full sm:w-auto"
                >
                  <FaTimesCircle className="mr-1" />
                  Reject
                </Button>
                <Button
                  onClick={() => setApproveModal(true)}
                  className="w-full sm:w-auto"
                >
                  <FaCheckCircle className="mr-1" />
                  Approve
                </Button>
              </div>
            </div>
          </div>

          {/* Tab Section */}
          <div className="flex">
            <button
              className={`relative mt-4 sm:mt-5 rounded-tl-xl px-3 pr-8 sm:pr-10 py-2 sm:py-3 text-xs sm:text-[14px] font-bold ${
                activeTab === "general"
                  ? "text-[#111827] bg-white"
                  : "text-[#14B8A6] bg-[#F0FDFA]"
              }`}
              style={{
                clipPath: "polygon(0 0, 70% 0, 100% 100%, 0% 100%)",
              }}
            >
              General Info
            </button>
          </div>

          {/* Fields Section - Made more responsive */}
          <div className="bg-white shadow rounded-r-lg rounded-b-lg p-4 sm:p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              {/* Type */}
              <div className="space-y-1">
                <Label className="text-sm sm:text-base">Type</Label>
                {showLoading ? (
                  <Skeleton className="w-24 h-6 sm:w-28 sm:h-6 rounded-full" />
                ) : (
                  <div
                    className={`inline-block px-2 sm:px-3 py-1 text-xs sm:text-sm font-semibold rounded-full ${
                      requestData.type === "Transaction"
                        ? "text-blue-600 bg-white border border-blue-500"
                        : "text-gray-500 border border-gray-500"
                    }`}
                  >
                    {requestData.type}
                  </div>
                )}
              </div>

              {/* Community */}
              <div className="space-y-1">
                <Label className="text-sm sm:text-base">Profile ID</Label>
                <div className="p-1 sm:p-2 border-b-2 border-gray-300 text-sm">
                  {showLoading ? (
                    <Skeleton className="w-32 h-4 sm:w-40 sm:h-6" />
                  ) : (
                    requestData.requestProfileId
                  )}
                </div>
              </div>

              {/* Account Name Profile */}
              <div className="space-y-1">
                <Label className="text-sm sm:text-base">Account Name</Label>
                <div className="p-1 sm:p-2 border-b-2 border-gray-300 text-sm">
                  {showLoading ? (
                    <Skeleton className="w-32 h-4 sm:w-40 sm:h-6" />
                  ) : (
                    requestData.requestEntityName
                  )}
                </div>
              </div>

              {/* Profile Name */}
              <div className="space-y-1">
                <Label className="text-sm sm:text-base">Profile Name</Label>
                <div className="p-1 sm:p-2 border-b-2 border-gray-300 text-sm">
                  {showLoading ? (
                    <Skeleton className="w-32 h-4 sm:w-40 sm:h-6" />
                  ) : (
                    requestData.profileName
                  )}
                </div>
              </div>

              {/* Description (Full Width) */}
              <div className="md:col-span-2 space-y-1">
                <Label className="text-sm sm:text-base">Description</Label>
                <div className="p-1 sm:p-2 border-b-2 border-gray-300 text-sm">
                  {showLoading ? (
                    <Skeleton className="w-full h-4 sm:h-6" />
                  ) : (
                    requestData.description
                  )}
                </div>
              </div>

              <div className="md:col-span-2">
                <hr className="my-2 sm:my-4" />
              </div>

              {/* Transaction-specific fields */}
              {isTransactionReview && (
                <>
                  <div className="space-y-1">
                    <Label className="text-sm sm:text-base">
                      Transaction ID
                    </Label>
                    <div className="p-1 sm:p-2 border-b-2 border-gray-300 text-sm">
                      {showLoading ? (
                        <Skeleton className="w-32 h-4 sm:w-40 sm:h-6" />
                      ) : (
                        requestData.requestId
                      )}
                    </div>
                  </div>

                  <div className="space-y-1">
                    <Label className="text-sm sm:text-base">
                      Material Category
                    </Label>
                    {showLoading ? (
                      <Skeleton className="w-32 h-10 sm:w-40 sm:h-10" />
                    ) : (
                      <MaterialSelectTransactions
                        value={editableData.materialId}
                        onChange={handleMaterialChange}
                        className="w-full"
                      />
                    )}
                  </div>

                  <div className="space-y-1">
                    <Label className="text-sm sm:text-base">POC ID</Label>
                    <div className="p-1 sm:p-2 border-b-2 border-gray-300 text-sm">
                      {showLoading ? (
                        <Skeleton className="w-32 h-4 sm:w-40 sm:h-6" />
                      ) : (
                        requestData.pocId
                      )}
                    </div>
                  </div>

                  <div className="space-y-1">
                    <Label className="text-sm sm:text-base">Quantity</Label>
                    {showLoading ? (
                      <Skeleton className="w-32 h-10 sm:w-40 sm:h-10" />
                    ) : (
                      <div className="relative">
                        <Input
                          type="number"
                          value={editableData.quantity || ""} // Ensure we pass empty string if undefined
                          onChange={handleQuantityChange}
                          className="pr-12" // Make space for the unit
                        />
                        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none text-sm text-gray-500">
                          {requestData?.unit}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="space-y-1">
                    <Label className="text-sm sm:text-base">POC Name</Label>
                    <div className="p-1 sm:p-2 border-b-2 border-gray-300 text-sm">
                      {showLoading ? (
                        <Skeleton className="w-32 h-4 sm:w-40 sm:h-6" />
                      ) : (
                        requestData.pocName
                      )}
                    </div>
                  </div>

                  <div className="space-y-1">
                    <Label className="text-sm sm:text-base">
                      Transaction Points
                    </Label>
                    <div className="p-1 sm:p-2 border-b-2 border-gray-300 text-sm">
                      {showLoading ? (
                        <Skeleton className="w-32 h-4 sm:w-40 sm:h-6" />
                      ) : (
                        editableData.transactionPoints ||
                        (selectedMaterial?.point ||
                          requestData.materialPoint ||
                          0) * (editableData.quantity || 0)
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="md:col-span-2">
                <hr className="my-2 sm:my-4" />
              </div>

              {/* Comment (Full Width) */}
              <div className="md:col-span-2 space-y-1">
                <Label className="text-sm sm:text-base">Comment</Label>
                <TextArea
                  placeholder="Enter comment here"
                  className="w-full p-2 border-b-2 border-gray-300 text-sm"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Approve Modal */}
      <Modal
        isOpen={approveModal}
        onClose={() => setApproveModal(false)}
        title="Approve Request"
        description="Are you sure you want to approve this request?"
        icon={<FaCheckCircle className="text-green-500" />}
        iconColor="green"
        actions={
          <div className="flex justify-between w-full">
            <Button
              variant={"secondary"}
              onClick={() => setApproveModal(false)}
            >
              Cancel
            </Button>
            <Button onClick={handleConfirmApprove} disabled={loading}>
              {loading ? "Approving..." : "Approve"}
            </Button>
          </div>
        }
      ></Modal>

      {/* Reject Modal */}
      <Modal
        isOpen={rejectModal}
        onClose={() => setRejectModal(false)}
        title="Reject Request"
        description="Are you sure you want to reject this request?"
        icon={<FaTimesCircle className="text-red-500" />}
        iconColor="red"
        actions={
          <div className="flex justify-between w-full">
            <Button variant={"secondary"} onClick={() => setRejectModal(false)}>
              Cancel
            </Button>
            <Button
              variant={"destructive"}
              onClick={handleConfirmReject}
              disabled={loading}
            >
              {loading ? "Rejecting..." : "Reject"}
            </Button>
          </div>
        }
      ></Modal>
    </div>
  );
};

export default ViewUserPage;
